import { Select, SelectItem } from '../../../../components/Select';
import React, { useEffect } from 'react';
import { useCreateOperator } from '../../../../contexts/CreateOperatorContext';
import { useSort } from '../../../../hooks/useSort';

export const BranchSelect = () => {
  const { branches, operator, loading, updateOperator } = useCreateOperator();
  const { sortAsc } = useSort<OperatorBranch>('name');

  useEffect(() => {
    if (branches.length > 0)
      updateOperator(
        'mediaRoomSettings',
        Object.assign(operator.mediaRoomSettings!, {
          branch: branches[branches.length - 1].id,
        })
      );
  }, [branches.length]);

  if (operator.mediaRoomSettings === undefined) return null;

  return (
    <Select
      className="min-w-[80px]"
      disabled={loading}
      required
      onChange={(event) =>
        updateOperator(
          'mediaRoomSettings',
          Object.assign(operator.mediaRoomSettings!, {
            branch: event.target.value,
          })
        )
      }
      value={operator.mediaRoomSettings?.branch ?? ''}
      variant="contained"
    >
      {branches.sort(sortAsc).map((branch, index) => (
        <SelectItem key={`operator-branch-${index + 1}`} value={branch.id}>
          {branch.name}
        </SelectItem>
      ))}
    </Select>
  );
};
